import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { BankDepositsHistoryPage } from '@/features/treasury/components/BankDepositsHistoryPage';

const searchSchema = z.object({
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/treasury/bank-deposits/')({
  component: BankDepositsHistoryPage,
  validateSearch: searchSchema,
});
